import {
    ApplicationConfig,
    inject,
    LOCALE_ID,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners
} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {provideTranslateService} from "@ngx-translate/core";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {MsalBroadcastService, MsalGuard, MsalInterceptor, MsalService} from "@azure/msal-angular";
import {MSAL_PROVIDERS} from "./auth/msal.config";

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        ...MSAL_PROVIDERS,
        {provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true},
        MsalService,
        MsalGuard,
        MsalBroadcastService,

        // MSAL v3+ requires async initialize() before any other call.
        provideAppInitializer(async () => {
            const msal = inject(MsalService);
            await msal.instance.initialize();
            await msal.instance.handleRedirectPromise();
        }),
        {provide: LOCALE_ID, useValue: 'nl'},
        provideTranslateService({
            lang: 'nl',
            fallbackLang: 'nl',
            loader: provideTranslateHttpLoader({
                prefix: '/i18n/',
                suffix: `.json?v=${Date.now()}`
            })
        }),
        provideRouter(routes),
    ]
};
